<template>
  <Head title="Dashboard" />
  <div v-if="showAllEvents.length > 0" class="absolute bg-orfBlue-100 top-0 left-0 w-full h-screen bg-opacity-20 z-50 flex items-center justify-center" @click="showAllEvents = []" >
    <div @click.stop class="flex flex-col bg-white p-8 border-orfBlue-100 shadow-xl relative">
      <HeroIcon name="x-mark" outline class="w-7 h-7 absolute top-1 right-1 fill-orfBlue-100 text-orfBlue-100 transform hover:scale-125 cursor-pointer transition-transform 0.5s ease-in-out" @click="showAllEvents = []"/>
      <h1 class="mb-2 text-center text-gray-500 font-bold">Alle Events</h1>
      <div class="mb-2 text-center text-2xl text-orfBlue-100 font-bold mt-2">{{ formatDateTime(showAllEvents[0]['startDate'], 'dddd, LL') }}</div>
      <div class="my-1 text-center" :class="'text-' + getWorkload(showAllEvents[0]['startDate']).color">
        {{getWorkload(showAllEvents[0]['startDate']).text}}
      </div>
      <div v-for="event in showAllEvents" :key="event.key" class="p-1 my-0.5 rounded-sm bg-opacity-10 relative" @click="allEventClicked(event)" :class="[ auth.user.id == event.customData.user.id ? 'edit bg-orfBlue-100' : 'bg-büro-100 text-büro-100']">
        {{event.title}}
      </div>
    </div>
  </div>
  <div v-if="showPopup" class="absolute bg-orfBlue-100 top-0 left-0 w-full h-screen bg-opacity-20 z-50 flex items-center justify-center" @click="setShowPopup(false, 'create')" >
    <div @click.stop class="flex flex-col bg-white p-8 border-orfBlue-100 shadow-xl relative">
      <HeroIcon name="x-mark" outline class="w-7 h-7 absolute top-1 right-1 fill-orfBlue-100 text-orfBlue-100 transform hover:scale-125 cursor-pointer transition-transform 0.5s ease-in-out" @click="setShowPopup(false, 'create')"/>
      <h1 class="mb-2 text-center text-gray-500 font-bold">{{popupType == 'edit' ? 'Termin bearbeiten' : 'Neuer Termin'}}</h1>
      <div class="mb-2 text-center text-2xl text-orfBlue-100 font-bold mt-2">{{ formatDateTime((popupType == 'edit' ? form.start : selectedDay), 'dddd, LL') }}</div>
      <form @submit.prevent="store(popupType == 'edit')" class="flex flex-col items-center">
        <select-input v-model="form.type" :pre="form.type ? form.type : 'büro'" :error="form.errors.type" min-w row class="flex items-center justify-between my-2 w-40 w-full font-bold p-0.5" label="Art">
          <option value="büro">Büro</option>
          <option hidden value="homeoffice">Homeoffice</option>
          <option value="urlaub">Urlaub</option>
        </select-input>
        <div v-if="form.type == 'urlaub'" class="flex items-center justify-between w-full max-w-xs">
          <DatePicker locale="de" class="flex flex-wrap" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.start" is24hr :minute-increment="15">
            <template v-slot="{ inputValue, inputEvents }">
              <div class="w-full">
                <div class="flex items-center justify-between">
                  <label class="form-label flex-grow mb-0 font-bold" for="startDate">Von</label>
                  <input id="startDate" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                </div>
                <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
              </div>
            </template>
          </DatePicker>
          <DatePicker locale="de" class="flex flex-wrap ml-2" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.end" is24hr :minute-increment="15">
            <template v-slot="{ inputValue, inputEvents }">
              <div class="w-full">
                <div class="flex items-center justify-between">
                  <label class="form-label flex-grow mb-0 font-bold" for="endDate">Bis</label>
                  <input id="endDate" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                </div>
                <div v-if="form.errors.end" class="form-error">{{ form.errors.end }}</div>
              </div>
            </template>
          </DatePicker>
        </div>
        <DatePicker v-else locale="de" class="flex flex-wrap w-full" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.start" is24hr :minute-increment="15">
          <template v-slot="{ inputValue, inputEvents }">
              <div class="flex items-center justify-between w-full">
                <label class="form-label mb-0 font-bold" for="startDate">Datum</label>
                <input id="startDate" class="form-input ml-2 w-32" :value="inputValue" v-on="inputEvents" />
              </div>
              <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
          </template>
        </DatePicker>
        <!--          <div class="flex flex-wrap justify-center my-1 w-full max-w-xs text-center">
                    <textarea-input v-model="form.description" :error="form.errors.description" class="w-full" placeholder="Beschreibung (optional)" />
                  </div>-->
        <div class="flex flex-col items-center justify-center gap-4 px-8 pt-8 py-4 border-t border-gray-100">
          <loading-button :text="popupType == 'edit' ? 'Termin aktualisieren' : 'Termin erstellen'" icon-name="save" icon-custom-icon/>
          <loading-button v-if="popupType == 'edit'" text="Termin löschen" func="delete" small inverted icon-name="trash" icon-mini @click.prevent="destroy"/>
        </div>
      </form>
      <div v-for="errors in form.errors">{{ errors }}</div>
    </div>
  </div>
    <div class="flex items-center mb-6 flex-wrap justify-center">
      <loading-button v-if="dashboard" text="Mein Kalender" :inverted="true" icon-name="calendar" icon-custom-icon func="link" :href="'/users/' + auth.user.id" class="sm:mb-0 lg:mr-4"/>
      <loading-button v-else text="Dashboard" :inverted="true" icon-name="arrow-left" func="link" href="/" class=" sm:mb-0 lg:mr-4"/>
      <div class="flex-grow">
        <Search v-if="dashboard" href="/" :users="users" :filters="dashboard" :auth="auth" />
        <div v-if="user" class="flex items-center font-bold text-orfBlue-100">
          <HeroIcon name="user-circle" mini class="mr-2 h-8 w-8 fill-orfBlue-100" />
          <div class="mt-1">{{user.first_name}} {{user.last_name}}</div>
        </div>
        <div v-else-if="department && !dashboard" class="flex items-center font-bold text-orfBlue-100">
          <HeroIcon name="flag" class="mr-2 h-8 w-8 fill-orfBlue-100" />
          <div class="mt-1">{{department.name}}</div>
        </div>
      </div>
      <div class="flex items-center my-4 sm:my-0">
        <loading-button text="Office" :inverted="eventMode != 'büro'" icon-name="büro" icon-custom-icon small @click.prevent="setEventMode('büro')"/>
        <loading-button text="Urlaub" :inverted="eventMode != 'urlaub'" icon-name="urlaub" icon-custom-icon small @click.prevent="setEventMode('urlaub')"/>
      </div>
      <div class="flex justify-between items-center text-sm cursor-pointer" @click.prevent="showWeekends = !showWeekends">
        <div class="w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out" :class="{ 'bg-orfBlue-100': showWeekends}">
          <div class="bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out" :class="{ 'translate-x-6': showWeekends,}"></div>
        </div>
        <h2 class="ml-2">Wochenende anzeigen</h2>
      </div>
    </div>
    <div class="flex">
      <div class="relative border-4 flex flex-col w-full" style="min-height: 500px;">
        <div v-if="dashboard || (department && !user)" class="w-full flex shadow-inner">
          <div class="w-20 cursor-pointer p-2 flex-grow text-center border relative border-gray-100 border-opacity-30 text-xs md:text-normal hover:font-bold hover:bg-orfBlue-100 hover:text-white transition-colors 1s ease-in-out" :class="{'border-b-0 font-bold bg-orfBlue-100 text-white' : selectedTeam == 'all'}"  @click="selectedTeam='all'">
            Alle
          </div>
          <div v-for="team in teams" :key="team.id" class="w-20 cursor-pointer p-2 flex-grow text-center border relative border-gray-100 border-opacity-30 text-xs md:text-normal hover:font-bold hover:bg-orfBlue-100 hover:text-white transition-colors 1s ease-in-out" :class="{'border-b-0 font-bold bg-orfBlue-100 text-white' : selectedTeam == team.id}"  @click="selectedTeam=team.id">
            {{team.name}}
          </div>
        </div>
        <div class="days-grid bg-white">
          <div id="app" class="relative">
            <div v-if="loading" class="absolute h-full w-full top-0 left-0 flex items-center justify-center bg-orfBlue-100 opacity-50 z-50">
              <div class="btn-spinner-big border-urlaub-100 absolute transform z-50" />
            </div>
            <calendar-view
              :show-date="showDate" :items="items" :display-period-uom="mode" :starting-day-of-week="1" :display-period-count="1"
              :class="{'monthly' : mode == 'month'}"
              :item-content-height="mode == 'month' ? '18px' : '30px'"
              weekday-name-format="long"
              :item-border-height="getGap"
              :item-top="getTop"
              @click-date="setSelectedDay"
              @click-item="eventClicked"
            >
              <template #header="{ headerProps }">
                  <div class="hidden lg:flex items-center py-2 px-6 w-full relative">
                    <div class="w-1/4 flex">
                      <loading-button no-text :inverted="true" icon-name="chevron-left" icon-mini small @click.prevent="setShowDate(headerProps.previousPeriod)"/>
                      <loading-button text="Heute" :inverted="formatDateTime(new Date(), 'LL') != formatDateTime(showDate, 'LL')" icon-name="map-pin" small @click.prevent="setShowDate(new Date())"/>
                      <loading-button no-text :inverted="true" icon-name="chevron-right" icon-mini small @click.prevent="setShowDate(headerProps.nextPeriod)"/>
                    </div>
                    <div class="flex-grow flex items-center justify-center">
                      <slot name="label">
                      <DatePicker locale="de" class="flex flex-wrap" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="showDate" is24hr :minute-increment="15">
                        <template v-slot="{ inputValue, inputEvents }">
                              <label class="text-xl cursor-pointer" for="startDate">{{ headerProps.periodLabel }}
                                <input id="startDate" @change="setShowDate(showDate)" class="w-0" :value="inputValue" v-on="inputEvents" />
                              </label>
                        </template>
                      </DatePicker>
                      </slot>
                    </div>
                    <div class="w-1/4 flex justify-end">
                      <loading-button text="Woche" :inverted="getMode != 'week'" :icon-name="getMode == 'week' ? 'eye' : 'eye-slash'" icon-custom-icon small @click.prevent="setMode('week')"/>
                      <loading-button text="Monat" :inverted="getMode != 'month'" :icon-name="getMode == 'month' ? 'eye' : 'eye-slash'" icon-custom-icon small @click.prevent="setMode('month')"/>
                    </div>
                  </div>

                  <div class="flex lg:hidden justify-center my-2">
                    <loading-button text="Woche" :inverted="getMode != 'week'" :icon-name="getMode == 'week' ? 'eye' : 'eye-slash'" icon-custom-icon small @click.prevent="setMode('week')"/>
                    <loading-button text="Monat" :inverted="getMode != 'month'" :icon-name="getMode == 'month' ? 'eye' : 'eye-slash'" icon-custom-icon small @click.prevent="setMode('month')"/>
                  </div>
                  <div class="flex lg:hidden justify-center">
                    <loading-button v-if="formatDateTime(new Date(), 'LL') != formatDateTime(showDate, 'LL')" text="Heute" :inverted="true" icon-name="map-pin" small @click.prevent="setShowDate(new Date())"/>
                  </div>
                  <div class="flex lg:hidden items-center py-2 px-6 w-full relative">
                    <div class="w-1/4 flex">
                      <loading-button no-text :inverted="true" icon-name="cheveron-left" small @click.prevent="setShowDate(headerProps.previousPeriod)"/>
                    </div>
                    <div class="flex-grow flex items-center justify-center">
                      <slot name="label">
                        <div class="text-sm lg:text-xl">{{
                          headerProps.periodLabel
                          }}</div>
                      </slot>
                    </div>
                    <div class="w-1/4 flex justify-end">
                      <loading-button no-text :inverted="true" icon-name="cheveron-right" small @click.prevent="setShowDate(headerProps.nextPeriod)"/>
                    </div>
                  </div>
              </template>
              <template #dayHeader="{ index, nr, label }">
                <div class="flex-1 text-center border py-2 font-bold text-xxs lg:text-lg" :class="index">
                  {{label}}
                </div>
              </template>
              <template #dayContent="{ day }">
                <div class="text-center w-full justify-center text-xs" :class="'text-' + getWorkload(day).color">
                  <div v-if="(mode == 'month' && dashboard || team == 'all') && eventMode == 'büro'" class="cv-dayInfo relative opacity-80 hidden lg:flex text-center justify-center bg-transparent">
                    {{getWorkload(day).text}}
                  </div>
                  <div v-if="getWorkload(day).count > 5 && mode == 'month'" class="absolute bottom-0 right-0 w-full flex flex-grow items-center bg-white z-40 group">
                    <button class="text-orfBlue-100 flex items-center flex justify-start px-1.5 pl-2 transition-transform 0.5s ease-in-out transform group-hover:scale-125" @click.stop="getAllEvents(day)" style="font-size: 10px; padding-top: 0.3em; padding-bottom: 0.3em;">
                      <div class="flex items-center">
                        <div class="mt-0.5"> + {{getWorkload(day).count - 5}} Mehr</div>
                      </div>
                    </button>
                  </div>
                  <div v-if="formatDateTime(day, 'LL') == formatDateTime(new Date, 'LL')" class="absolute top-0 right-0 p-0.5 lg:pb-0 px-1 items-center flex bg-white text-xxs lg:text-sm z-20 text-orfBlue-100">
                    <div class="hidden lg:flex">
                      Heute
                    </div>
                    <HeroIcon name="map-pin" class="w-4 text-sm h-4"/>
                  </div>
                </div>
              </template>
            </calendar-view>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import HeroIcon from '@/Shared/HeroIcon.vue'
import moment from "moment/moment";
import LoadingButton from "@/Shared/LoadingButton.vue";
import Search from "@/Shared/Search.vue";
import SelectInput from "@/Shared/SelectInput.vue";
import TextareaInput from "@/Shared/TextareaInput.vue";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import {Inertia} from "@inertiajs/inertia";
import axios from "axios";

export default {
  components: {
    CalendarView,
    SelectInput,
    Search,
    LoadingButton,
    Head,
    Link,
    HeroIcon,
  },
  props: {
    events: Object,
    week: Object,
    departmentSeats: Number,
    today: String,
    teams: Array,
    auth: Object,
    users: Array,
    team: Number,
    dashboard: Boolean,
    department: Object,
    user: Object,
    monthView: {
      default: false,
      type: Boolean
    },
    weekends: {
      default: false,
      type: Boolean
    },
    eventType: {
      default: 'büro',
      type: String
    },
  },
  layout: Layout,
  data() {
    console.log(this.events)
    return {
      items: this.events,
      loading: false,
      showWeekends: this.weekends,
      weekCount: this.weekends ? 7 : 5,
      weekCountDisplay: this.weekends ? 'unset' : 'none',
      eventsCount: [],
      selectionStart: null,
      selectionEnd: null,
      selectedDay: new Date().setHours(0),
      selectedTeam: this.team,
      showAllEvents: [],
      isVisibleByType: {
        urlaub: false,
        homeoffice: true,
        büro: true,
      },
      form: this.$inertia.form({
        description: null,
        start: new Date().setHours(0),
        end: new Date().setHours(0),
        startDate: new Date().setHours(0),
        endDate: new Date().setHours(0),
        type: 'büro',
        timestamp: true,
        redirectBack: true,
      }),
      masks: {
        weekdays: 'WWW',
      },
      showDate: new Date(),
      mode: 'week',
      showPopup: false,
      popupType: 'create',
      eventMode: this.eventType,
      selectedEvent: null,
    }
  },
  computed : {
    getMode() {
      return this.mode
    },
    getTop() {
      if (this.mode == 'month'){
        return '2em'
      } else {
        return window.innerWidth < 600 ? '3em' : '2em'
      }
    },
    getGap() {
      if (this.mode == 'month'){
        return window.innerWidth < 600 ? '4px' : '4px'
      } else {
        return window.innerWidth < 600 ? '0em' : '2px'
      }
    },
  },
  mounted() {

  },
  watch: {
    selectedTeam: {
      deep: true,
      handler: throttle(function () {
        let data = {
          'teamId': this.selectedTeam,
          'newDate': moment(this.showDate).format('YYYY-MM-DD'),
          'eventType': this.eventMode,
        }
        this.loading = true
        this.$inertia.reload({only: ['team', 'teams', 'events', 'eventType'], data: pickBy(data), preserveState: true, onSuccess: () => {this.items = this.events; this.loading = false, this.eventMode = this.eventType}, progress: false});
      }, 250)
    },
    selectedDay: {
      deep: true,
      handler: throttle(function () {
        this.form.start = new Date(this.selectedDay).setHours(0)
        this.form.end = new Date(this.selectedDay).setHours(0)
      }, 250)
    },
    showWeekends: {
      deep: true,
      handler: throttle(function () {
        this.weekCount = this.showWeekends ? 7 : 5
        this.weekCountDisplay = this.showWeekends ? 'unset' : 'none'
      }, 250)
    },
  },
  methods: {
    destroy() {
      if (confirm('Are you sure you want to delete this event?')) {
        this.loading = true
        this.$inertia.delete(`/events/${this.selectedEvent}`, {onSuccess: () => {this.setShowPopup(false, 'create'); this.getEvents(this.showDate)}})
      }
    },
    setShowPopup(value, type){
      this.showPopup = value;
      this.popupType = type
      this.form.start = new Date(this.selectedDay).setHours(0)
      this.form.end = new Date(this.selectedDay).setHours(0)
    },
    getAllEvents(day){
      this.showAllEvents = this.items.filter(event => moment(event.startDate).format('LL') == moment(day).format('LL'));
    },
    eventClicked(item) {
      if (item.originalItem.customData.user.id == this.auth.user.id) {
        this.setShowPopup(true, 'edit')
        this.form.start = new Date(item.startDate)
        this.form.end = new Date(item.endDate)
        this.form.description = item.description
        this.form.type = item.originalItem.customData.type
        this.selectedEvent = item.id
      }
    },
    allEventClicked(item){
      if (item.customData.user.id == this.auth.user.id){
        this.setShowPopup(true, 'edit')
        this.form.start = new Date(item.startDate)
        this.form.end = new Date(item.endDate)
        this.form.description = item.description
        this.form.type = item.customData.type
        this.selectedEvent = item.id
      }
    },
    getWeekday(d){
      return moment(d).weekday( ) + 1;
    },
    getWorkload(day) {
      let events = this.items.filter(event => moment(event.startDate).format('LL') == moment(day).format('LL')).length;
      let max = this.departmentSeats
      let workload = max - events
      let array = {color : null, text: null, count: 0}
      if (workload < 0){
        array.color = 'orfRed-500'
        array.text = 'überfüllt' +  ' ' + events + '/' + max
        array.result = max - events
        array.count = events
        array.max = max
      } else if (workload == 0){
        array.color = 'orfRed-500'
        array.text = 'voll' +  ' ' + events + '/' + max
        array.result = 0
        array.count = events
        array.max = max
      } else if (workload < 3) {
        array.color = 'orange-400'
        array.text = (max - events) + '/' + max + ' frei'
        array.result = max - events
        array.count = events
        array.max = max
      } else {
        array.color = 'green-600'
        array.text = (max - events) + '/' + max + ' frei'
        array.result = max - events
        array.count = events
        array.max = max
      }
      return array
    },
    setSelectedDay(d){
      this.selectedDay = d
      let oldSelection = document.querySelector('.today')
      let newSelection = document.querySelector('.d' + moment(d).format('MM-DD'))
      if (oldSelection != null) {
        oldSelection.classList.remove('today')
      }
      if (newSelection != null){
        newSelection.classList.add('today')
      }
      this.setShowPopup(true, 'create')
    },
    setShowDate(d) {
      this.loading = true
      this.getEvents(d)
    },
    getEvents(newDate, modeChange){
      let data = {
        newDate: moment(newDate).format('YYYY-MM-DD'),
        userId: this.user ? this.user.id : null,
        teamId: this.team,
        departmentId: this.department ? this.department.id : null,
        eventType: this.eventMode
      }
      axios.get('/getEventsFromPeriod', { params: data})
        .then(response => {
          this.items = response.data
          this.showDate = newDate
          this.selectedDay = newDate
          if (modeChange){
            this.mode = this.eventMode == 'urlaub' ? 'month' : 'week'
          }
          this.loading = false
          console.log('events updated');
        });
    },
    setMode(m) {
      this.mode = m;
    },
    setEventMode(m) {
      this.loading = true
      this.eventMode = m;
      this.getEvents(this.showDate, true)
      this.form.type = m;
    },
    hexToRgbA(hex, op = '01') {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + (op ? op : '0.1)')
      }
      throw new Error('Bad Hex')
    },
    formatDateTime: function (date = new Date(), format = 'LL') {
      return moment(date).format(format)
    },
    isSelectedDay(date){
      return this.formatDateTime(this.selectedDay, 'LL') == this.formatDateTime(date, 'LL')
    },
    store(edit) {
      this.form.start = new Date(this.form.start).setHours(0)
      this.form.end = new Date(this.form.type == 'urlaub' ? this.form.end : this.form.start).setHours(0)
      this.loading = true
      if (this.getWorkload(this.form.start).count <= 0){
        if (edit){
          this.form.put(`/events/${this.selectedEvent}`, {onSuccess: () => {this.setShowPopup(false, 'create'); this.getEvents(this.showDate)}})
        } else {
          this.form.post('/events', {onSuccess: () => {this.setShowPopup(false, 'create'); this.getEvents(this.showDate)}})
        }
      } else {
        if (edit){
          this.form.put(`/events/${this.selectedEvent}`, {onSuccess: () => {this.setShowPopup(false, 'create'); this.getEvents(this.showDate)}})
        } else {
          this.form.post('/events', {onSuccess: () => {this.setShowPopup(false, 'create'); this.getEvents(this.showDate)}})
        }
      }
    },
  },
}
</script>
<style>

.edit:before {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
    font-size: 0.7em;
    content: 'Bearbeiten';
}
@media(max-width: 800px) {
  .edit:before {
    display: none;
  }
}

.edit {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}
.edit:hover {
  transform: scale(1.05);
  background-color: #0f1f5d !important;
  color: white !important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

.cv-item {
  margin: 0px 0.425em !important;
}

.cv-item.span1 {
  width: calc(100%/7 - 0.85em);
}

.cv-wrapper.monthly .cv-weekdays > div.cv-item{
  font-size: 12px !important;
}

@media(max-width: 800px){
  .cv-wrapper .cv-weekdays > div.cv-item{
    font-size: 10px !important;
    text-overflow: ellipsis;
  }

  .cv-wrapper.monthly .cv-weekdays > div.cv-item{
    font-size: 9px !important;
  }
}

.cv-wrapper{
  display:flex;
  flex-direction:column;
  flex-grow:1;
  height:100%;
  min-height:100%;
  max-height:100%;
  overflow-x:hidden;
  overflow-y:hidden
}
.cv-wrapper,.cv-wrapper div.cv-item{
  box-sizing:border-box;
  line-height:1em;
  font-size:1em
}
.cv-header-days{
  display:flex;
  flex-grow:0;
  flex-shrink:0;
  flex-basis:auto;
  flex-flow:row nowrap;
  border-width:0 0 0 1px
}
.cv-header-day{
  display:flex;
  flex-grow:1;
  flex-shrink:0;
  flex-basis:0;
  flex-flow:row nowrap;
  align-items:center;
  justify-content:center;
  text-align:center;
  border-width:1px 1px 0 0
}
.cv-weeks{
  display:flex;
  flex-grow:1;
  flex-shrink:1;
  flex-basis:auto;
  flex-flow:column nowrap;
  border-width:0 0 1px 1px;
  overflow-y:hidden;
  -ms-overflow-style:none;
  scrollbar-width:none;
}
.cv-weeknumber{
  width:2rem;
  position:relative;
  text-align:center;
  border-width:1px 1px 0 0;
  border-style:solid;
  line-height:1
}
.cv-week{
  display:flex;
  flex-grow:1;
  flex-shrink:1;
  flex-basis:0;
  flex-flow:row nowrap;
  min-height:3em;
  border-width:0;
  position:relative;
  width:100%;
  overflow-y:auto;
  -ms-overflow-style:none
}
.cv-weekdays{
  display:flex;
  flex-grow:1;
  flex-shrink:0;
  flex-basis:0;
  flex-flow:row nowrap;
  direction:ltr;
  position:relative;
  overflow-y:hidden;
  scrollbar-width:none
}
.cv-day{
  display:flex;
  flex-grow:1;
  flex-shrink:0;
  flex-basis:0;
  position:relative;
/*  position:sticky;*/
  top:0;
  border: 1px solid #eee;
  direction:initial;
  transition: border-color 0.2s ease-in-out;
}

.cv-day:hover{
  border: 2px solid #000e78;
  transition: border-color 0.5s ease-in-out;
  cursor: pointer;
}

.cv-day.today{
  border: 2px solid #000e78;
}

.cv-day-number{
  height:auto;
  align-self:flex-start;
  font-size: 14px;
  width: 25px;
  text-align: center;
}

.cv-day:hover .cv-day-number {
  background-color: #000e78;
  color: white;
}

.cv-day.today .cv-day-number {
  background-color: #000e78;
  color: white;
}

@media(max-width: 800px) {
  .cv-day-number{
    font-size: 12px;
  }
  .cv-day:hover .cv-day-number {
    font-size: 10px;
    width: 20px;
  }

  .cv-day.today .cv-day-number {
    font-size: 10px;
    width: 20px;
  }
}
.cv-day-number:hover:after{
  position:absolute;
  top:1rem;
  background-color:var(--cal-holiday-bg, #f7f7f7);
  border:var(--cal-holiday-border, 1px solid #f0f0f0);
  box-shadow:.1rem .1rem .2rem var(--cal-holiday-shadow, rgba(0, 0, 0, .25));
  padding:.2rem;
  margin:.5rem;
  line-height:1.2
}
.cv-day[draggable],.cv-item[draggable]{
  -webkit-user-select:none;
  -moz-user-select:none;
  user-select:none
}
.cv-item{
  position:absolute;
  white-space:nowrap;
  overflow:hidden;
  background-color:#f7f7f7;
  border-width:1px;
  direction:initial;
  margin: 0px 0.425em !important;
}
.cv-wrapper.wrap-item-title-on-hover .cv-item:hover{
  white-space:normal;
  z-index:1
}
.cv-header-days,.cv-header-day,.cv-weeks,.cv-week,.cv-item{
  border-style:solid;
  border-color:#ddd
}
.cv-item .endTime:before{
  content:"-"
}
.cv-header-day,.cv-day-number,.cv-item{
  padding:.2em
}
.cv-day-number:before{
  margin-right:.5em
}

.cv-item.offset0{
  left:0
}
.cv-item.offset1{
  left: calc(100%/v-bind(weekCount))
}
.cv-item.offset2{
  left: calc(200%/v-bind(weekCount))
}
.cv-item.offset3{
  left: calc(300%/v-bind(weekCount))
}
.cv-item.offset4{
  left: calc(400%/v-bind(weekCount))
}
.cv-item.offset5{
  left: calc(500%/v-bind(weekCount))
}
.cv-item.offset6{
  left: calc(600%/v-bind(weekCount))
}
.cv-item.span1{
  width: calc((100%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span2{
  width: calc((200%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span3{
  width: calc((300%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span4{
  width: calc((400%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span5{
  width: calc((500%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span6{
  width: calc((600%/v-bind(weekCount)) - 0.85em);
}
.cv-item.span7{
  width: calc((700%/v-bind(weekCount)) - 0.85em);
}
.cv-weeks::-webkit-scrollbar,.cv-weekdays::-webkit-scrollbar{
  width:0;
  background:transparent
}
.cv-header{
  display:flex;
  flex:0 1 auto;
  flex-flow:row nowrap;
  align-items:center;
  min-height:2.5em;
  border-width:1px 1px 0 1px
}
.cv-header .periodLabel{
  display:flex;
  flex:1 1 auto;
  flex-flow:row nowrap;
  min-height:1.5em;
  line-height:1;
  font-size:1.5em
}
.cv-header,.cv-header button{
  border-style:solid;
  border-color:#ddd
}
.cv-header-nav,.cv-header .periodLabel{
  margin:.1em .6em
}
.cv-header-nav button,.cv-header .periodLabel{
  padding:.4em .6em
}
.cv-header button{
  box-sizing:border-box;
  line-height:1em;
  font-size:1em;
  border-width:1px
}

.dow6, .dow0 {
  display: v-bind(weekCountDisplay);
}

.outsideOfMonth .cv-day-number {
  opacity: 0.3;
}

.btn-spinner-big {
  height: 6em;
  width: 6em;
  position: relative;
  border-radius: 50%;
  border-top-color: rgba(255,255,255,1) !important;
  border-left-color: rgba(255,255,255,0.7) !important;
  border-bottom-color: rgba(255,255,255,0.4)  !important;
  border-right-color: rgba(255,255,255,0.1)  !important;
  border: 14px dotted transparent;
  transform: translateZ(0);
  -webkit-animation: spinning 1s infinite linear;
  animation: spinning 1s infinite linear;
}

/*.cv-day:nth-child(2n){
  background-color: rgba(15, 31, 93, 0.03);
}*/


</style>
